import {
  useNormalizer,
} from '@sttedra_ui/framework';

const {
  getString,
  getNumber,
  getBoolean,
} = useNormalizer();

class RegisterApplicationsConsolidationApiResponseModel {
  // #region Props
  mitmaCode;
  stateId;
  stateCode;
  stateDescription;
  registeredDate;
  // #endregion

  constructor(data) {
    this.mitmaCode = getString(data?.mitmaCode);
    this.stateId = getNumber(data?.stateId);
    this.stateCode = getString(data?.stateCode);
    this.stateDescription = getString(data?.stateDescription);
    this.registeredDate = getString(data?.registeredDate);
    this.notificable = getBoolean(data?.notificable) || false;
  }

  isNotificableDetail() {
    return this.notificable && (this.stateId === 1 || this.stateId === 4);
  }
}

export default RegisterApplicationsConsolidationApiResponseModel;
